export default "__VITE_PUBLIC_ASSET__a18c8b52__"